import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { UpdateError } from '@/components/pages/Users/Index/hooks/useUploadCsv';

type Props = {
  children?: never;
  errors: UpdateError[];
};

export const CsvUpdateError: React.FC<Props> = ({ errors }) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Span>{t('text.user.csv.error')}</Span>
      <Div>
        {errors.map((error, index) => (
          <Message key={index}>{error.message}</Message>
        ))}
      </Div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 300px;
  width: 100%;
`;

const Span = styled.span`
  font-size: 14px;
  color: #999999;
`;

const Div = styled.div`
  max-height: 200px;
  overflow-y: scroll;
  margin-top: 16px;
`;

const Message = styled.p`
  font-size: 14px;
  color: #9f3a38;
`;
